<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title px-2 pt-2 pb-0 w-100">
        <div class="row">
          <div class="col-xl-3 col-12 mb-md-1" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="searchCommission(); changeQueryParams()" />
          </div>
          <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select [(ngModel)]="filter_customer" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchCommission(); changeQueryParams()">
              <ng-option [value]="0">
                <span class="font-small-4 font-weight-normal pr-2">{{ "CUSTOMER" | translate }}</span>
              </ng-option>
              <ng-option [value]="customer.id" *ngFor="let customer of customers_list">
                <span class="font-small-4 font-weight-normal pr-2">{{ customer.name }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select [(ngModel)]="filter_has_order" [closeOnSelect]="true" [searchable]="false" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchCommission(); changeQueryParams()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===2">{{ "ORDER" | translate }}: {{ "NO" | translate }}</span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===1">{{ "ORDER" | translate }}: {{ "YES" | translate }}</span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===0">{{ "FILTER_ORDER" | translate }}</span>
              </ng-template>
              <ng-option [value]="0">
                <span class="font-small-4 font-weight-normal pr-2">{{ "ALL" | translate }}</span>
              </ng-option>
              <ng-option [value]="1">
                <span class="font-small-4 font-weight-normal pr-2">{{ "YES" | translate }}</span>
              </ng-option>
              <ng-option [value]="2">
                <span class="font-small-4 font-weight-normal pr-2">{{ "NO" | translate }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select [(ngModel)]="filter_status_round" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchCommission(); changeQueryParams()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===-1">{{ "FILTER_STATE_ROUND" | translate }}</span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===0">{{ "STATE_ROUND" | translate }}: {{ "NOT_STARTED" | translate }}</span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===1">{{ "STATE_ROUND" | translate }}: {{ "ACTIVATED_MASCULIN" | translate }}</span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===2">{{ "STATE_ROUND" | translate }}: {{ "RENOVATED" | translate }}</span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===3">{{ "STATE_ROUND" | translate }}: {{ "CLOSE_MASCULIN" | translate }}</span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===4">{{ "STATE_ROUND" | translate }}: {{ "RENOVATED" | translate }}</span>
              </ng-template>
              <ng-option [value]="-1">
                <span class="font-small-4 font-weight-normal pr-2">{{ "ALL" | translate }}</span>
              </ng-option>
              <ng-option [value]="0">
                <span class="font-small-4 font-weight-normal pr-2">{{ "NOT_STARTED" | translate }}</span>
              </ng-option>
              <ng-option [value]="1">
                <span class="font-small-4 font-weight-normal pr-2">{{ "ACTIVATED_MASCULIN" | translate }}</span>
              </ng-option>
              <ng-option [value]="3">
                <span class="font-small-4 font-weight-normal pr-2">{{ "CLOSE_MASCULIN" | translate }}</span>
              </ng-option>
              <ng-option [value]="4">
                <span class="font-small-4 font-weight-normal pr-2">{{ "RENOVATED" | translate }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select [(ngModel)]="filter_status_commission" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchCommission(); changeQueryParams()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===0">{{ "OPENED_FEMALE" | translate }}: {{ "YES" | translate }}</span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===1">{{ "OPENED_FEMALE" | translate }}: {{ "NO" | translate }}</span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===-1">{{ "STATE_COMMISSION" | translate }}</span>
              </ng-template>
              <ng-option [value]="-1">
                <span class="font-small-4 font-weight-normal pr-2">{{ "STATE_COMMISSION" | translate }}</span>
              </ng-option>
              <ng-option [value]="0">
                <span class="font-small-4 font-weight-normal pr-2">{{ "OPENED_FEMALE" | translate }}</span>
              </ng-option>
              <ng-option [value]="1">
                <span class="font-small-4 font-weight-normal pr-2">{{ "CLOSED_FEMALE" | translate }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select [(ngModel)]="filter_type_order" [closeOnSelect]="true" [searchable]="false" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchCommission(); changeQueryParams()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===0">{{ "ORDER_TYPE" | translate }}: {{ "TIME_MATERIAL" | translate }} </span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===1">{{ "ORDER_TYPE" | translate }}: {{ "TASK" | translate }} </span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===2">{{ "ORDER_TYPE" | translate }}: {{ "PRODUCTS" | translate }} </span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===-1">{{ "TYPE_ORDER_FILTER" | translate }} </span>
              </ng-template>
              <ng-option [value]="-1">
                <span class="font-small-4 font-weight-normal pr-2">{{ "ALL" | translate }}</span>
              </ng-option>
              <ng-option [value]="0">
                <span class="font-small-4 font-weight-normal pr-2">{{ "TIME_MATERIAL" | translate }}</span>
              </ng-option>
              <ng-option [value]="1">
                <span class="font-small-4 font-weight-normal pr-2">{{ "TASK" | translate }}</span>
              </ng-option>
              <ng-option [value]="2">
                <span class="font-small-4 font-weight-normal pr-2">{{ "PRODUCTS" | translate }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select [(ngModel)]="filter_detachment" [searchable]="false" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchCommission(); changeQueryParams()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===1">{{ "DETACHMENT" | translate }}: {{ "YES" | translate }} </span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===2">{{ "DETACHMENT" | translate }}: {{ "NO" | translate }} </span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===0">{{ "DETACHMENT_FILTER" | translate }} </span>
              </ng-template>
              <ng-option [value]="0">
                <span class="font-small-4 font-weight-normal pr-2">{{ "ALL" | translate }}</span>
              </ng-option>
              <ng-option [value]="1">
                <span class="font-small-4 font-weight-normal pr-2">{{ "YES" | translate }}</span>
              </ng-option>
              <ng-option [value]="2">
                <span class="font-small-4 font-weight-normal pr-2">{{ "NO" | translate }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2 col-12">
            <ng-select [(ngModel)]="filterYear" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" [searchable]="false" (ngModelChange)="loadCommissions()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2">{{ "YEAR" | translate | titlecase }}: {{ item }} </span>
              </ng-template>
              <ng-option *ngFor="let year of yearsList" [value]="year">
                <span class="font-small-4 font-weight-normal pr-2">{{ year }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 col-12 fix-ng-select-clear">
            <ng-select [(ngModel)]="filterMonth" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="filterMonth > 0" [searchable]="false"
                       (clear)="filterMonth = 0" (ngModelChange)="searchCommission(); changeQueryParams()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item > 0">{{ "EXPIRE_MONTH" | translate }}: {{ monthsList[item - 1] | titlecase }}</span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="item < 1">{{ "SELECT_EXPIRE_MONTH" | translate }}</span>
              </ng-template>
              <ng-option *ngFor="let month of monthsList; let i = index" [value]="i+1">
                <span class="font-small-4 font-weight-normal pr-2">{{ month | titlecase }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 text-right" [ngClass.sm]="'col-12 mt-1'">
            <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" *ngIf="_utilService.isDesktop">
              <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
            </div>
            <div class="btn-group" has_capability="create_commission">
              <div ngbDropdown>
                <button ngbDropdownToggle class="btn btn-outline-primary" type="button" id="dropdownMenuButton" rippleEffect>
                  {{ "ADD" | translate }}
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                  <a ngbDropdownItem href="javascript:void(0)" routerLink="/dashboard/commission/create">{{ "DEAL_ORDER" | translate }}</a>
                  <a ngbDropdownItem href="javascript:void(0)" routerLink="/dashboard/commissions/create-product-commission">{{ "PRODUCT_COMMISSION" | translate }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--desktop-->
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 70 : 350"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="filterCommissions"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
        >
          <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" width="300" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <a *ngIf="!row.last_order?.isProductCommission" class="text-break-line-2" [ngbTooltip]="row.complete_name" [routerLink]="'/dashboard/commission/edit/' + row.id">{{
                    row.complete_name ? row.complete_name : "-"
                  }}</a>
                <a *ngIf="row.last_order?.isProductCommission" class="text-break-line-2" [ngbTooltip]="row.complete_name" [routerLink]="'/dashboard/commissions/edit-product-commission/' + row.id">{{
                    row.complete_name ? row.complete_name : "-"
                  }}</a>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'RESOURCES' | translate" [sortable]="false" width="80" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                  <span *ngIf="!row.detachment && row.last_order && row.last_order?.employees_names && row.last_order?.employees_names.length === 1" [ngbTooltip]="(row.last_order?.employees_names || []).join(', ')">
                    <i [data-feather]="'user'" size="19"></i>
                  </span>
                <span *ngIf="!row.detachment && row.last_order && row.last_order?.employees_names && row.last_order?.employees_names.length > 1" [ngbTooltip]="(row.last_order?.employees_names || []).join(', ')">
                    <i [data-feather]="'users'" size="19"></i>
                  </span>
                <span *ngIf="row.detachment && row.last_order && row.last_order?.employees_names && row.last_order?.employees_names.length > 0" [ngbTooltip]="(row.last_order?.employees_names || []).join(', ')">
                    <i [data-feather]="'repeat'" size="19"></i>
                  </span>
                <span *ngIf="row.last_order && row.last_order?.products_names && row.last_order?.products_names.length > 0" [ngbTooltip]="(row.last_order?.products_names || []).join(', ')">
                    <i [data-feather]="'package'" size="19"></i>
                  </span>
                <span class="ml-075" *ngIf="!row.last_order.empty && !!row.last_order.from && !!row.last_order.to && row.last_order?.isTimeMaterial" [ngbTooltip]="'TIME_MATERIAL' | translate">
                    <i [data-feather]="'clock'" size="19"></i>
                  </span>
                <span class="ml-075" *ngIf="!row.last_order.empty && !!row.last_order.from && !!row.last_order.to && !row.last_order?.isTimeMaterial && !row.last_order?.isProductCommission" [ngbTooltip]="'TASK' | translate">
                    <i [data-feather]="'calendar'" size="19"></i>
                  </span>
                <span *ngIf="!row.last_order.empty && !row.last_order.from && !row.last_order.to">-</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'FROM' | translate" prop="last_order.from" width="90" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{row.orders.length > 0 ? (row.orders[row.orders.length - 1].from | date: "dd/MM/yyyy") : ''}}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TO' | translate" prop="last_order.to" width="90" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span *ngIf="row.orders.length > 0 && !!row.orders[0].closed_date">{{row.orders[0].closed_date | date: "dd/MM/yyyy"}}</span>
              <span *ngIf="row.orders.length > 0 && !row.orders[0].closed_date">{{row.orders[0].to | date: "dd/MM/yyyy"}}</span>
              <span *ngIf="row.orders.length > 0 && !row.orders[0].closed_date && !row.orders[0].to">-</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CAPACITY' | translate" prop="last_order.capacity" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.last_order?.capacity ? (row.last_order?.capacity | currency: "EUR") : "-" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'RESIDUE' | translate" prop="last_order.residue" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.last_order?.residue ? (row.last_order?.residue | currency: "EUR") : "-" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'STATE' | translate" prop="status" *ngIf="_utilService.isDesktop && filter_status_commission === -1" width="50">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.status === 1 ? ("CLOSED_FEMALE" | translate) : ("OPENED_FEMALE" | translate) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ORDER' | translate" prop="last_order.has_order" width="75" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
                <span (click)="_utilService.getFile(row.last_order?.file_url)" class="text-success cursor-pointer" *ngIf="!!row.last_order?.file_url" [ngbTooltip]="'HAS_ORDER' | translate">
                  <i [data-feather]="'file-text'" size="19"></i>
                </span>
              <span class="text-danger" *ngIf="!row.last_order?.file_url" [ngbTooltip]="'HAS_NOT_ORDER' | translate"><i [data-feather]="'x'" size="19"></i></span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'STATE_ROUND' | translate" prop="last_order.label" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
                <span class="badge badge-pill badge-{{ row.last_order?.status_color }}" [ngbTooltip]="row.last_order.closed_date ? row.last_order.closed_date : row.last_order.nextRound ? row.last_order.nextRound.from + ' ' + row.last_order.nextRound.to : null">
                  {{ row.last_order?.label | translate}}
                </span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" width="75" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <button class="bg-transparent border-0 text-danger" (click)="deleteCommission(row)" [ngbTooltip]="'DELETE' | translate" has_capability="delete_commission">
                  <span [data-feather]="'trash-2'" size="16" class="mr-50"></span>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12 mb-1">
                  <div class="d-flex">
                    <span *ngIf="!row.last_order.empty" [class]="row.last_order?.isTimeMaterial ? 'type_commission_material' : 'type_commission_task'" [ngbTooltip]="row.last_order?.isTimeMaterial ? ('TIME_MATERIAL' | translate) : ('TASK' | translate)">&nbsp;</span>
                    <a class="text-break-line-2" [ngbTooltip]="row.complete_name" [routerLink]="'/dashboard/commission/edit/' + row.id">{{ row.complete_name ? row.complete_name : "-" }}</a>
                  </div>
                </div>
                <div class="col-12 d-flex">
                  <span class="font-weight-bold mr-075">{{ "PRODUCTS" | translate }}: </span>
                  <div class="d-flex">
                      <span *ngIf="!row.detachment && row.last_order && row.last_order?.employees_names && row.last_order?.employees_names.length === 1" [ngbTooltip]="(row.last_order?.employees_names || []).join(', ')">
                        <i [data-feather]="'user'" size="19"></i>
                      </span>
                    <span *ngIf="!row.detachment && row.last_order && row.last_order?.employees_names && row.last_order?.employees_names.length > 1" [ngbTooltip]="(row.last_order?.employees_names || []).join(', ')">
                        <i [data-feather]="'users'" size="19"></i>
                      </span>
                    <span *ngIf="row.detachment && row.last_order && row.last_order?.employees_names && row.last_order?.employees_names.length > 0" [ngbTooltip]="(row.last_order?.employees_names || []).join(', ')">
                        <i [data-feather]="'repeat'" size="19"></i>
                      </span>
                    <span *ngIf="row.last_order && row.last_order?.products_names && row.last_order?.products_names.length > 0" [ngbTooltip]="(row.last_order?.products_names || []).join(', ')">
                        <i [data-feather]="'package'" size="19"></i>
                      </span>
                    <span class="ml-075" *ngIf="!row.last_order.empty && !!row.last_order.from && !!row.last_order.to && row.last_order?.isTimeMaterial" [ngbTooltip]="'TIME_MATERIAL' | translate">
                        <i [data-feather]="'clock'" size="19"></i>
                      </span>
                    <span class="ml-075" *ngIf="!row.last_order.empty && !!row.last_order.from && !!row.last_order.to && !row.last_order?.isTimeMaterial" [ngbTooltip]="'TASK' | translate">
                        <i [data-feather]="'calendar'" size="19"></i>
                      </span>
                    <span *ngIf="!row.last_order.empty && !row.last_order.from && !row.last_order.to">-</span>
                  </div>
                </div>

                <div class="col-12">
                  <span class="font-weight-bold">{{ "FROM" | translate }}: </span>
                  <span>{{ row.last_order?.from ? (row.last_order?.from | date: "dd/MM/yyyy") : "-" }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "TO" | translate }}: </span>
                  <span>{{ row.last_order?.to ? (row.last_order?.to | date: "dd/MM/yyyy") : "-" }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "CAPACITY" | translate }}: </span>
                  <span>{{ row.last_order?.capacity ? (row.last_order?.capacity | currency: "EUR") : "-" }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "RESIDUE" | translate }}: </span>
                  <span>{{ row.last_order?.residue ? (row.last_order?.residue | currency: "EUR") : "-" }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "STATE_COMMISSION" | translate }}: </span>
                  <span>{{ row.status === 1 ? ("CLOSED_FEMALE" | translate) : ("OPENED_FEMALE" | translate) }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "ORDER" | translate }}: </span>
                  <span (click)="!!row.last_order?.file_url ? _utilService.getFile(row.last_order?.file_url) : null" class="text-success" *ngIf="row.last_order?.has_order === 1" [ngbTooltip]="'HAS_ORDER' | translate">
                      <i [data-feather]="'file-text'" size="19"></i>
                    </span>
                  <span class="text-danger" *ngIf="row.last_order?.has_order === 2" [ngbTooltip]="'HAS_NOT_ORDER' | translate"><i [data-feather]="'x'" size="19"></i></span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "STATE_ROUND" | translate }}: </span>
                  <span class="badge badge-pill badge-{{ row.last_order?.status_color }}">{{ row.last_order?.label }}</span>
                </div>
                <div class="col-12 d-flex justify-content-end">
                  <!--Actions-->
                  <button class="bg-transparent border-0 text-danger" (click)="deleteCommission(row)" [ngbTooltip]="'DELETE' | translate" has_capability="delete_commission">
                    <span [data-feather]="'trash-2'" size="16" class="mr-50"></span>
                  </button>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
